var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"back-btn",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('HeroIcon',{attrs:{"name":"chevron-left","size":32,"stroke-width":2.5}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }